import Instance from "../../../../Axios";

// New Actions for the app

const GetWorkPermitEntities = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/workpermits/entities`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_WORK_PERMIT_ENTITIES", payload: data.yData });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetWorkPermitEntities;